import React, { useRef } from 'react'
import { type SignatureCanvas as SignatureCanvasType } from 'react-signature-canvas'

import Link from 'components/_old/Link/Link.jsx'
import { Typo } from 'components/_old/Typo'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'
import { Validate } from 'components/atoms/Validate'

import './Signature.css'
// need to use require here because SignatureCanvas uses CMJ for dev deps
// eslint-disable-next-line
const { SignatureCanvas } = require('react-signature-canvas')

type SignatureProps = {
  setValue: (value: string | null) => void
  validation: {
    rules: boolean[]
    errors: string[]
  }
  isForceValidationEnabled: boolean
}

const Signature = ({ setValue, validation, isForceValidationEnabled }: SignatureProps): React.ReactElement => {
  const sigRef = useRef<SignatureCanvasType>(null)

  const handleSignatureEnd = (): void => {
    const trimmedCanvas = sigRef.current?.getTrimmedCanvas()
    setValue(trimmedCanvas?.toDataURL() ?? null)
  }
  const clearSignature = (): void => {
    sigRef.current?.clear()
    setValue(null)
  }

  return (
    <React.Fragment>
      <Paper bottom={32}>
        <Typography size={24} lineHeight="small" weight="semibold">
          <Typo>Signature</Typo>
        </Typography>
      </Paper>
      <Paper bottom={12}>
        <Typography size={14}>
          <Typo>Draw your signature here using your mouse</Typo>
        </Typography>
      </Paper>
      <Validate rules={validation.rules} skipWaitBlur={isForceValidationEnabled}>
        {(_valid, brokenRule) => (
          <React.Fragment>
            <Paper bottom={1}>
              <Typography size={12} color="error">
                <Typo>{isForceValidationEnabled ? validation.errors[brokenRule] ?? ' ' : ' '}</Typo>
              </Typography>
            </Paper>
            <div className="SignatureContainer">
              <SignatureCanvas
                penColor="black"
                canvasProps={{ width: 720, height: 200, className: 'sigCanvas' }}
                ref={sigRef}
                onEnd={handleSignatureEnd}
              />
            </div>
            <Link onClick={clearSignature}>Clear</Link>
          </React.Fragment>
        )}
      </Validate>
    </React.Fragment>
  )
}

export { Signature }
